<script setup lang="ts">
import Teamfeeling from '@/components/illustrations/Teamfeeling.vue';
import { FmsType } from '@/types';
import { computed, inject } from 'vue';

const fmsType: FmsType = inject('fms-type') as FmsType;
const colorScheme = inject('colorScheme', 'yellow');
const nextSlide = inject('nextSlide');

const backgroundColor = computed(() => {
  return {
    purple: 'bg-purple-background',
    yellow: 'bg-yellow-background',
    green: 'bg-green-background',
    blue: 'bg-blue-background',
  }[colorScheme];
});

const footerColor = computed(() => {
  return {
    purple: 'bg-purple-lighter',
    yellow: 'bg-yellow-lighter',
    green: 'bg-green-lighter',
    blue: 'bg-blue-lighter',
  }[colorScheme];
});
</script>

<template>
  <div
    :class="[
      'w-full',
      'min-h-full',
      backgroundColor,
      'flex',
      'flex-col',
      'overflow-y-auto',
      'xl:items-start',
      'xl:text-left',
    ]"
  >
    <!-- Work Content -->
    <div
      class="px-8 text-[#171717] md:mt-[6%] landscape:mt-[48%] lg:landscape:mt-[5%] lg:mt-[0%] xl:w-[70%]"
      v-if="fmsType === FmsType.Work"
    >
      <h2
        class="font-light text-[25px] xs:my-3 my-8 md:text-5xl xs:text-[15px]"
      >
        Mitt liv på jobbet.
      </h2>
      <p class="text-lg md:text-3xl xs:text-[12px]">
        En stor del av dagens vakna timmar är du på jobbet.
        <br />Då är det viktigt att trivas och må bra.
      </p>
    </div>

    <!-- School Content -->
    <div
      class="px-8 text-[#171717] min-h-[400px] text-left md:max-w-full"
   
    >
      <h2 class="font-semibold xs:text-[24px] text-[32px] my-8 leading-tight">
        Ditt liv i skolan.
      </h2>
      <p class="text-2xl xs:text-[16px] leading-relaxed">
        En stor del av dagens vakna timmar är vi på skolan och då är det viktigt
        att vi trivs och mår bra. Nu ska du svara på frågor om din skolmiljö.
      </p>
    </div>

    <!-- Footer with Image and Button -->
    <div
      :class="[
        'w-full',
        'h-[200px]',
        footerColor,
        'mt-auto',
        'flex',
        'flex-col',
        'xl:flex-row',
        'xl:justify-between',
        'xl:items-center',
      ]"
    >
      <!-- Image: Adjusted positioning and width -->
      <div
        class="xl:w-1/2 xs:mt-2 sm:landscape:w-[45%] md:landscape:w-[33%] md:ml-[44%] lg:ml-[0%] xl:flex xl:justify-end mr-[20px] xs:pt-16 xs:w-[265px]"
      >
        <Teamfeeling
          class="mt-[-7rem] xs:pl-[55px] md:mt-[-35rem] landscape:mt-[-25rem] sm:landscape:mt-[-20rem] lg:mt-[-600px]"
          width="70%"
        />
      </div>

      <!-- Button: Ensuring correct order -->
      <div
        class="flex flex-col justify-between px-8 h-full xl:w-1/2 sm:order-last md:order-last lg:order-last xl:order-first mt-4 xl:mt-[-22%]"
      >
        <b-button
          class="lg:mt-[120px] xs:mt-2 xl:mt-[120px] small:mb-14"
          @click="nextSlide"
          >Sätt igång</b-button
        >
      </div>
    </div>
  </div>
</template>

<!-- 
<script setup lang="ts">
import Teamfeeling from "@/components/illustrations/Teamfeeling.vue";
import { FmsType } from "@/types";
import { computed, inject } from "vue";

const fmsType: FmsType = inject("fms-type") as FmsType;
const colorScheme = inject("colorScheme", "yellow");
const nextSlide = inject("nextSlide");

const backgroundColor = computed(() => {
  return {
    purple: "bg-purple-background",
    yellow: "bg-yellow-background",
    green: "bg-green-background",
    blue: "bg-blue-background",
  }[colorScheme];
});

const footerColor = computed(() => {
  return {
    purple: "bg-purple-lighter",
    yellow: "bg-yellow-lighter",
    green: "bg-green-lighter",
    blue: "bg-blue-lighter",
  }[colorScheme];
});
</script>

<template>
  <div
    :class="[
      'w-full',
      'min-h-full',
      backgroundColor,
      'flex',
      'flex-col',
      'overflow-y-auto',
      'xl:items-start',
      'xl:text-left',
    ]"
  >
    <div
      class="px-8 text-[#171717]  md:mt-[6%] landscape:mt-[48%] lg:landscape:mt-[5%] lg:mt-[0%] xl:w-[70%]"
      v-if="fmsType === FmsType.Work"
    >
      <h2 class="font-light text-[25px] my-8 md:text-5xl">
        Mitt liv på jobbet.
      </h2>
      <p class="text-lg md:text-3xl">
        En stor del av dagens vakna timmar är du på jobbet.
        <br/>Då är det viktigt att trivas och må bra.
      </p>
    </div>

    <div
      class="px-8 text-[#171717] min-h-[400px]"
      v-if="fmsType === FmsType.School"
    >
      <h2 class="font-semibold text-[32px] my-8 leading-tight">Ditt liv i skolan.</h2>
      <p class="text-xl leading-relaxed">
        En stor del av dagens vakna timmar är vi på skolan och då är det viktigt
        att vi trivs och mår bra. Nu ska du svara på frågor om din skolmiljö.
      </p>
    </div>

    <div
      :class="[
        'w-full',
        'h-[232px]',
        footerColor,
        'mt-auto',
        'flex',
        'flex-col',
        'xl:flex-row',
        'xl:justify-between',
        'xl:items-center',
      ]"
    >
      <div class="xl:w-1/2  sm:landscape:w-[45%] md:landscape:w-[33%] md:ml-[44%] lg:ml-[0%] xl:flex xl:justify-end mr-[20px]">
        <Teamfeeling
          class="mt-[-7rem] md:mt-[-35rem] landscape:mt-[-25rem] sm:landscape:mt-[-20rem] lg:mt-[-600px]"
          width="70%"
        />
      </div>
      <div
        class="flex flex-col justify-between px-8 h-full xl:w-1/2 sm:order-last md:order-last lg:order-last xl:order-first mt-4 xl:mt-[-22%]"
      >
        <b-button class="mb-12 " @click="nextSlide">Sätt igång</b-button>
      </div>
    </div>
  </div>
</template>
 -->
